import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllDesg } from "../redux/slice/designationListSlice";
import { fetchAllRoles } from "../redux/slice/getRolesPermissionListSlice";
import { fetchWorkingModeShift } from "../redux/slice/workingMode&ShiftSlice";
import { fetchAllDept } from "../redux/slice/departmentSlice";
import { fetchAllActiveEmp } from "../redux/slice/getAllActiveEmpSlice";

export default function useCredentialMasterData(isEnabled = false) {
  const dispatch = useDispatch();

  const { workingModeShift } = useSelector(state => state.workingModeShift);
  const { designation } = useSelector(state => state.designation);
  const { department } = useSelector(state => state.department);
  const { roles } = useSelector(state => state.rolePermission);
  const { activeEmp } = useSelector(state => state.activeEmp);

  useEffect(() => {
    if (!isEnabled) return; // Only runs when modal 'show' is true
    
    // Check if data is already in Redux before dispatching
    if (!workingModeShift || Object.keys(workingModeShift).length === 0) {
      dispatch(fetchWorkingModeShift());
    }
    if (!designation || designation.length === 0) {
      dispatch(fetchAllDesg());
    }
    if (!department || department.length === 0) {
      dispatch(fetchAllDept());
    }
    if (!roles || roles.length === 0) {
      dispatch(fetchAllRoles());
    }
    if (!activeEmp || activeEmp.length === 0) {
      dispatch(fetchAllActiveEmp());
    }
  }, [dispatch,isEnabled]);

  return { workingModeShift, designation, roles, department, activeEmp };
}
